'use client'

import React from 'react'
import { redirectToUrl } from '@/app/(app)/hooks/useAppBridgeRedirect'

const APP_URL = (process.env.NEXT_PUBLIC_APP_URL || 'https://app.sigmasense.pk').replace(/\/$/, '')
const API_KEY = (process.env.NEXT_PUBLIC_SHOPIFY_API_KEY || '').trim()

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const handleReload = () => {
    if (typeof window !== 'undefined') {
      window.location.reload()
    }
  }

  const handleReconnect = () => {
    if (typeof window === 'undefined') return
    try {
      const params = new URLSearchParams(window.location.search)
      const hashParams = new URLSearchParams(window.location.hash.replace(/^#/, ''))
      const shop = params.get('shop') || hashParams.get('shop') || window.localStorage.getItem('shopify-shop')
      const host = params.get('host') || hashParams.get('host') || window.localStorage.getItem('shopify-host')
      if (shop && host) {
        const url = `${APP_URL}/api/auth?shop=${encodeURIComponent(shop)}&host=${encodeURIComponent(host)}`
        redirectToUrl(url, { host, shop })
      } else {
        redirectToUrl(`${APP_URL}/signin`)
      }
    } catch {
      window.location.reload()
    }
  }

  return (
    <html lang="en">
      <head>
        <link rel="preconnect" href="https://cdn.shopify.com" crossOrigin="" />
        {/* App Bridge on every page - required for embedded app highlight */}
        {/* eslint-disable-next-line @next/next/no-sync-scripts */}
        <script
          src="https://cdn.shopify.com/shopifycloud/app-bridge.js"
          data-api-key={API_KEY}
        />
        <meta name="shopify-api-key" content={API_KEY} />
      </head>
      <body style={{ fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif', margin: 0, padding: '24px' }}>
        <div style={{ maxWidth: '480px', margin: '40px auto' }}>
          <h1 style={{ fontSize: '1.5rem', marginBottom: '8px' }}>Something went wrong</h1>
          <p style={{ color: '#6d7175', marginBottom: '24px' }}>
            An unexpected error occurred. Try reloading the page or reconnecting to the app.
          </p>
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <button
              type="button"
              onClick={handleReload}
              style={{
                padding: '8px 16px',
                fontSize: '14px',
                borderRadius: '8px',
                border: '1px solid #ccc',
                background: '#fff',
                cursor: 'pointer',
              }}
            >
              Reload
            </button>
            <button
              type="button"
              onClick={handleReconnect}
              style={{
                padding: '8px 16px',
                fontSize: '14px',
                borderRadius: '8px',
                border: 'none',
                background: '#008060',
                color: '#fff',
                cursor: 'pointer',
              }}
            >
              Reconnect
            </button>
            <button
              type="button"
              onClick={reset}
              style={{
                padding: '8px 16px',
                fontSize: '14px',
                borderRadius: '8px',
                border: '1px solid #ccc',
                background: '#fff',
                cursor: 'pointer',
              }}
            >
              Try again
            </button>
          </div>
        </div>
      </body>
    </html>
  )
}
